export default "__VITE_ASSET__Lwd$onwB__"